import SeoHead from './SeoHead';
import { Breadcrumbs } from './ComponentLibrary';
import { pageMeta } from '../seoUtils';

function BlogGuidelinesPage() {
  const seo = pageMeta({
    title: 'Contributor Guidelines',
    description:
      'What NaijaNest expects from Property Guide contributors, what publication does and does not mean, and how to report a problematic article.',
    path: '/blog/guidelines',
  });
  return (
    <div className="static-page blog-guidelines-page">
      <SeoHead title={seo.fullTitle} description={seo.desc} url={seo.url} image={seo.img} />
      <Breadcrumbs
        items={[
          { label: 'Home', href: '/' },
          { label: 'Property Guide', href: '/blog' },
          { label: 'Contributor Guidelines', current: true },
        ]}
      />
      <section className="section">
        <header className="agent-verification-policy-page__intro">
          <h1>Contributor Guidelines</h1>
          <p className="static-page__lead">Effective date: 9 August 2026.</p>
        </header>

        <h2>1. Who can contribute</h2>
        <p>
          Property consultants, estate agents, property developers, property managers,
          investors, property analysts, landlords, homeowners, and other property professionals
          can apply to become a contributor. Every application is reviewed by NaijaNest before
          approval.
        </p>

        <h2>2. What to write about</h2>
        <p>Contributor articles must be property-related: renting, buying, investment, market trends, neighbourhood guides, property development, land, and similar topics.</p>

        <h2>3. Content rules</h2>
        <p>Articles must not contain:</p>
        <ul>
          <li>fraudulent or misleading property claims;</li>
          <li>defamatory statements about identifiable people or businesses;</li>
          <li>spam or undisclosed advertising;</li>
          <li>plagiarised or copyright-infringing material;</li>
          <li>fabricated statistics or sources;</li>
          <li>private or personal information published without permission; or</li>
          <li>abusive, hateful, threatening, or discriminatory language.</li>
        </ul>
        <p>Third-party material (quotes, data, images) must be properly attributed.</p>

        <h2>4. Review process</h2>
        <p>
          Every submission is checked by an automated content-safety pass and then reviewed by an
          admin before publication. An admin may approve an article, request changes, or reject
          it. Drafts, submitted, and rejected articles are never publicly visible - only
          published articles appear on the Property Guide.
        </p>

        <h2>5. No endorsement</h2>
        <p>
          Publishing a contributor&rsquo;s article does not mean NaijaNest endorses the views,
          opinions, or advice it contains. Contributor articles are clearly labelled as such.
          NaijaNest does not describe contributors as &ldquo;verified experts&rdquo; unless an
          explicit verification process exists for that claim.
        </p>

        <h2>6. Legal, financial and investment content</h2>
        <p>
          Articles that touch on legal, financial, or investment matters are general information,
          not professional advice. Readers should seek independent, qualified advice before
          acting on anything in a Property Guide article.
        </p>

        <h2>7. Moderation actions</h2>
        <p>Depending on the severity of a violation, NaijaNest may:</p>
        <ul>
          <li>request changes to an article before it can be resubmitted;</li>
          <li>reject an article;</li>
          <li>unpublish or archive a previously published article; or</li>
          <li>suspend a contributor&rsquo;s ability to publish new articles.</li>
        </ul>

        <h2>8. Reporting a problem</h2>
        <p>
          Any reader can report a published article using the Report button on the article page.
          NaijaNest reviews every report.
        </p>

        <h2>Important</h2>
        <p>
          NaijaNest is a marketplace and publishing platform, not the author of contributor
          content. Readers should apply their own judgement and independent research alongside
          anything they read in the Property Guide.
        </p>
      </section>
    </div>
  );
}

export default BlogGuidelinesPage;
